export default "__VITE_ASSET__Y0i7DDtC__"